export class zfTranslations {
    static get(key, lang) {
        if (lang == undefined) {
            const html = document.querySelector("html");
            if (html == null)
                lang = "en";
            else
                lang = html.lang;
        }
        var trans = "";
        var langObj = this.translations[key];
        if (langObj != undefined) {
            trans = langObj[lang];
            if (trans == undefined || trans == "" || trans == "null") {
                if (langObj["en"] != undefined)
                    trans = langObj["en"];
                else if (langObj["de"] != undefined)
                    trans = langObj["de"];
                else
                    trans = "";
            }
        }
        return trans;
    }
}
